import '../sass/image-carousel.scss';

(() => {
    const swiperScript = document.querySelector('#ofg-education-swiper-js');
    const $blocks = document.querySelectorAll('.image-carousel');

    if (!$blocks) return;

    $blocks.forEach($block => {
        const $carousel = $block.querySelector('.image-carousel__carousel');
        const $carouselPagination = $block.querySelector('.image-carousel__pagination');
        const $carouselNavigationPrev = $block.querySelector('.image-carousel__navigation-btn--prev');
        const $carouselNavigationNext = $block.querySelector('.image-carousel__navigation-btn--next');

        const initCarousel = () => {
            if (!$carousel) return;

            const carousel = new Swiper($carousel, {
                spaceBetween: 0,
                pagination: {
                    el: $carouselPagination,
                    clickable: true,
                },
                keyboard: {
                    enabled: true,
                },
                rewind: true,
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                    }
                }
            });

            if ($carouselNavigationPrev) {
                $carouselNavigationPrev.addEventListener('click', () => {
                    carousel.slidePrev();
                });
            }

            if ($carouselNavigationNext) {
                $carouselNavigationNext.addEventListener('click', () => {
                    carousel.slideNext();
                });
            }
        };

        if (typeof Swiper !== 'undefined') {
            initCarousel();
        } else if (swiperScript) {
            swiperScript.addEventListener('load', () => {
                initCarousel();
            });
        } else {
            window.addEventListener('load', () => {
                const swiperScript = document.querySelector('#icrav-2027-swiper-js');

                console.log(swiperScript);

                if (!swiperScript) return;

                initCarousel();
            });
        }
    });
})();
